import React from 'react';
import CaseStudyPage from './CaseStudyPage';
import { caseStudies } from './caseStudyContent';

export default function GrandGamingCaseStudy() {
  return <CaseStudyPage study={caseStudies.grandGaming} />;
}
